<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <div class="points-info" style="display: flex; flex-wrap: wrap; margin-bottom: 5px;" v-if="jgYwList && jgYwList.length > 0">
      <div v-for="item in jgYwList" :key="item.ywcode" style="background: #fff; border-radius: 4px; box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1); padding: 12px 15px; margin-right: 10px; margin-bottom: 10px; width: 260px; border: 1px solid #ebeef5; display: flex; align-items: center; justify-content: space-between;">
        <div style="font-weight: bold; font-size: 15px; color: #303133;">
          {{item.ywmc}}
        </div>
        <div style="display: flex;">
          <div style="margin-right: 15px; text-align: center;">
             <div style="color: #67C23A; font-weight: bold; font-size: 18px; line-height: 1.2; margin-bottom: 2px;">{{item.zhyejf}}</div>
             <div style="color: #909399; font-size: 12px;">剩余积分</div>
          </div>
          <div style="text-align: center;">
             <div style="color: #F56C6C; font-weight: bold; font-size: 18px; line-height: 1.2; margin-bottom: 2px;">-{{item.zrxhjf || 0}}</div>
             <div style="color: #909399; font-size: 12px;">昨日消耗</div>
          </div>
        </div>
      </div>
    </div>
    <div class="thyjl-search">
      <el-date-picker
        v-model="xhsj"
        type="date"
        placeholder="选择积分消耗日期"
        style="width: 180px;margin-right: 10px;margin-bottom: 10px;">
      </el-date-picker>
      <el-input v-model="xueyuanMc" clearable placeholder="请输入学生姓名" style="width: 180px;margin-right: 10px;margin-bottom: 10px;"></el-input>
      <el-select v-model="ywcode" clearable placeholder="请选择业务" style="width: 180px;margin-right: 10px;margin-bottom: 10px;">
        <el-option v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :value="item.ywcode"></el-option>
      </el-select>
      <el-button @click="searchJfxhjl" style="margin-right: 10px;margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      <el-button type="primary" @click="xueyuanJfxhExport" style="margin-bottom: 10px;" icon="el-icon-download">导出</el-button>
    </div>
    <div class="thyjl-table">
      <el-table	:data="tableData" border :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
        <el-table-column type="index" align="center" width="80" label="序号">
        </el-table-column>
        <el-table-column prop="xueyuanBm" label="学生编号">
        </el-table-column>
        <el-table-column prop="xueyuanMc" label="学生姓名">
        </el-table-column>
        <el-table-column prop="ywmc" label="业务名称">
        </el-table-column>
        <el-table-column prop="xhjf" label="消耗积分">
        </el-table-column>
        <el-table-column align="center" width="170" label="消耗时间">
          <template slot-scope="scope">
            {{formatDate(new Date(scope.row.xhsj),'yyyy-MM-dd hh:mm')}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="page-zj"
          v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total">
      </el-pagination>

    </div>
	</div>
</template>

<script>
	export default{
		name: "jfxhjl",
		data() {
		  return {
        jgglId: sessionStorage.getItem("jgglId"),
        loading: false,
        tableData: [],
        page: { page: 1, size: 10, total: 0 },
        xhsj: '',//消耗时间
        xueyuanMc: '',//学员名称
        ywcode: '',//业务code
        ywList: [],//业务列表
        jgYwList: [], // 机构业务积分列表
		  }
		},
		mounted() {
      this.findJgYwList();
      this.findJgglView();
			this.findXueyuanJfxhPage();
		},
		methods: {
      findJgglView(){
        var _this = this;
        _this.$post('jggl/JgglController/jgglView', {id: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            if(rep.result.jggl && rep.result.jggl.ywList){
               _this.jgYwList = rep.result.jggl.ywList;
            }
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      findJgYwList(){
        var _this = this;
        _this.$post('bjgl/JgglController/findJgglYwListByJgglId', {jgglId: _this.jgglId}).then((rep) => {
          if (rep.code == 1) {
            _this.ywList = rep.result.ywList;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      },
      xueyuanJfxhExport(){
        var access_token = sessionStorage.getItem("access_token");
        var url = "api/xueyuan/XueyuanController/xueyuanJfxhExport";
        url = url + "?access_token=" + access_token
            +"&jgglId="+ this.jgglId
            +"&xhsj="+ (this.xhsj == null || this.xhsj == '' ? '' :this.formatDate(this.xhsj, 'yyyy-MM-dd'))
            +"&xueyuanMc="+ this.xueyuanMc
            +"&ywcode="+ (this.ywcode == null ? '' : this.ywcode);
        console.log(url);
        window.location.href = url;
      },
      searchJfxhjl(){
        var _this = this;
        _this.page.page = 1;
        _this.findXueyuanJfxhPage();
      },
      findXueyuanJfxhPage(){
        var _this = this;
        var params = {
          jgglId: _this.jgglId,
          xhsj: _this.xhsj == null || _this.xhsj == '' ? '' :_this.formatDate(_this.xhsj, 'yyyy-MM-dd'),
          xueyuanMc: _this.xueyuanMc,
          ywcode: _this.ywcode,
          page: _this.page.page - 1,
          size: _this.page.size
        }
        _this.loading = true;
        _this.$post('xueyuan/XueyuanController/xueyuanJfxhPage',params).then((rep) => {
          _this.loading = false;
          if (rep.code == 1) {
            _this.tableData = rep.result.page.content;
            _this.page.total = rep.result.page.totalElements;
          } else {
            _this.$message({
              type: "error",
              message: rep.msg
            });
          }
				})
			},
      // 每页条数
      handleSizeChange(val) {
        this.page.size = val;
        this.findXueyuanJfxhPage();
      },
      // 当前页
      handleCurrentChange(val) {
        this.page.page = val;
        this.findXueyuanJfxhPage();
      },
		}
	}
</script>

<style lang="less" scoped>
  .thyjl-search{
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
	.thyjl-table{
		.el-table{
		}
		.page-zj{
			width: 90%;
			text-align: right;
			margin: 0 auto;
			margin-top: 20px;
		}
	}
</style>